var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntellijIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IntelliJ IDEA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.0363882%",
    y1: "51.0173323%",
    x2: "178.130095%",
    y2: "41.8613414%",
    id: "intellijLinearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC801D",
    offset: "9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B07F61",
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577DB3",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E7CE6",
    offset: "53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFA",
    offset: "59%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.5573972%",
    y1: "114.759971%",
    x2: "35.5746707%",
    y2: "1.07475519%",
    id: "intellijLinearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2857",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB3979",
    offset: "8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E4997",
    offset: "16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7557B2",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5362C8",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#386CDA",
    offset: "44%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2373E8",
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1478F2",
    offset: "66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B7BF8",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.5510351%",
    y1: "23.6142262%",
    x2: "81.8011925%",
    y2: "129.75542%",
    id: "intellijLinearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2857",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE295F",
    offset: "8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D76",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF318C",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA3896",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B248AE",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A63D6",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFA",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#intellijLinearGradient-1)",
    points: "40.5333333 180.56 2.88 150.826667 25.04 109.786667 58.3466667 120.933333"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#087CFA",
    points: "256 68.24 251.386667 216.506667 152.773333 256 99.0666667 221.333333"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#intellijLinearGradient-2)",
    points: "256 68.24 207.2 115.84 144.533333 38.96 175.466667 4.18666667"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#intellijLinearGradient-3)",
    points: "99.0666667 221.333333 20.64 249.68 37.0666667 192.16 58.3466667 120.933333 0 101.413333 37.0666667 0 120.853333 9.89333333 207.2 115.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "49.1466667 48 209.146667 48 209.146667 208 49.1466667 208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0933333,177.76 L129.093333,177.76 L129.093333,187.76 L69.0933333,187.76 L69.0933333,177.76 Z M99.04,78.9866667 L99.04,68.0533333 L69.2,68.0533333 L69.2,78.9866667 L77.5733333,78.9866667 L77.5733333,116.746667 L69.2,116.746667 L69.2,127.68 L99.04,127.68 L99.04,116.746667 L90.6933333,116.746667 L90.6933333,78.9866667 L99.04,78.9866667 Z M127.466667,128.426667 L127.653333,128.533333 C123.58682,128.664911 119.554999,127.746501 115.946667,125.866667 C112.982684,124.270842 110.342051,122.136632 108.16,119.573333 L116.4,110.373333 C117.905422,112.072041 119.647771,113.544954 121.573333,114.746667 C123.293901,115.813234 125.282449,116.368178 127.306667,116.346667 C129.496863,116.452013 131.62583,115.606259 133.146667,114.026667 C134.7529,111.854759 135.511448,109.171394 135.28,106.48 L135.28,68 L148.613333,68 L148.613333,107.066667 C148.672828,110.230814 148.176405,113.380842 147.146667,116.373333 C145.369996,121.414006 141.364067,125.351037 136.293333,127.04 C133.451643,128.001896 130.466416,128.470875 127.466667,128.426667 Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellijIdea);
export default __webpack_public_path__ + "static/media/intellij-idea.fdd8ac821134799631acf8d98204f84c.svg";
export { ForwardRef as ReactComponent };